import { clearCookies } from "./cookie.service"
import config from "../environments/generated.config"
import { redirect } from "./redirect.service"

const homeUrl = config.urls.home

const logout = () => {
  console.log("logout")
  clearCookies()
  redirect(homeUrl)
}

export default logout
